<template lang="pug">
  .UserPicture.user-picture(
    :class="{ 'is_image': profile.image }",
  )
    span(
      class="user-picture__first-letter"
      v-text="profileFullName[0]"
    )
    .img(
      v-if="profile.image"
      :style="style",
    )
</template>

<script>
import { mapGetters } from 'vuex';
import SolidUserIcon from 'images/solid-user.svg';

export default {
  name: 'UserPicture',
  components: {
    SolidUserIcon,
  },
  computed: {
    ...mapGetters('profile', [
      'profile',
      'profileFullName',
    ]),
    style() {
      const { image } = this.profile;
      return { backgroundImage: `url(${image})` };
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.user-picture
  align-items: center
  display: flex
  justify-content: center
  position: relative
  align-items: center
  font-size: 35px
  width: 72px
  height: 72px
  border-radius: 100%
  +linearGradient(180deg, 0.2)
  @media screen and (max-width: 991px)
    width: 100px
    height: 100px
  .img
    width: 100%
    height: 100%
    position: absolute
    background-repeat: no-repeat
    background-size: contain
    border-radius: 100%
  &__first-letter
    +font(500)
    line-height: 30px
    text-align: center
    color: $secondary
  &:not(.is_image)
    .img
      width: 34px
      height: 34px
      background-size: 100%
      border-radius: 0
      background-position: center
      background-size: contain
      @media screen and (max-width: 991px)
        width: 47px
        height: 49px
</style>
